import type { Transaction } from "@shared/types/transaction";

// Field reset applied when duplicating a transaction (BasicDetailsModal,
// mode="duplicate"). A duplicate is a fresh draft, so the per-shipment
// identifiers are blanked — the copy gets a fresh external order number and
// fresh dates rather than inheriting the source's — and the logistician is
// cleared so the copy lands in the "nieprzypisane" (unassigned) logistics
// queue instead of being pre-assigned to the source's logistician.
export function buildDuplicateValues<T extends Partial<Transaction>>(tx: T): T {
  return {
    ...tx,
    external_id: null,
    pickup_date_from: null,
    load_date: null,
    load_time: null,
    unload_date: null,
    unload_time: null,
    logistics_employee_id: null,
  } as T;
}
